export default {
  data() {
    return {
      // ページに表示させる数
      mixinParPage: 10,
      // 今何ページ目にいるかを表す数
      mixinCurrentPage: 1,
      // 今のlistの一覧
      mixinList: [],
      // 合計レコード数
      mixinTotal: 0,
    }
  },
  methods: {
    // next prevのボタンが押下された時の現在のページを更新
    mixinClickCallback(pageNum) {
      this.mixinCurrentPage = Number(pageNum)
    },
    // 現在のページを１ページ目にクリア
    mixinCurrentPageClear() {
      this.mixinCurrentPage = 1
    },
    mixinSetPageNumber(pageNum) {
      this.mixinCurrentPage = Number(pageNum)
    },
    async mixinGetPageList(url, params = {}, headers = {}) {
      params.limit = this.mixinParPage
      params.offset = this.mixingGetOffset
      const res = await this.mixinGetAPIWithHeader(url, params, headers)
      if (res.headers['x-total-count']) {
        this.mixinTotal = Number(res.headers['x-total-count'])
      } else {
        this.mixinTotal = 0
      }
      return res.data
    },
  },
  computed: {
    // 一覧させるlistの処理
    mixinGetItems() {
      let current = this.mixinCurrentPage * Number(this.mixinParPage)
      let start = current - Number(this.mixinParPage)
      // this.mixinList = (this.list) ? this.list.slice(start, current) : []
      if (this.list) return this.list.slice(start, current)
      return null
    },
    // 何ページあるかの処理
    mixinGetPageCount() {
      if (this.mixinTotal !== 0) return Math.ceil(this.mixinTotal / this.mixinParPage)
      if (this.list)
        return Math.ceil(this.list.length / Number(this.mixinParPage))
      return 0
    },
    // ページ数を取得
    mixinGetForcePage() {
      return this.mixinCurrentPage
    },
    mixingGetOffset() {
      return (this.mixinCurrentPage - 1) * this.mixinParPage
    },
  },
}
